import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const OrgDashboardSelectOrgPageLoadable = clientOnlyLazy({
  loader: () => import('./OrgDashboardSelectOrgPage.dynamic'),
  loading: LoadableLoadingSection,
});
